import { Box, Heading, List, ListIcon, ListItem } from '@chakra-ui/react';
import { CheckedIcon } from '@udacity/chakra-uds-icons';

import { Card } from '~/components/card';
import { ContentContainer } from '~/components/container';
import { Glyph } from '~/components/glyph';
import { Markdown } from '~/components/markdown';

export type AcrossIndustriesSectionProps = {
  title: string | null;
  cards: Array<{
    title: string;
    glyphName: string;
    markdownContent: string;
  }> | null;
};

export function AcrossIndustriesSection({ title, cards }: AcrossIndustriesSectionProps) {
  if (!cards?.length) return null;
  return (
    <Box as='section'>
      <ContentContainer marginY='64px'>
        {!!title && (
          <Heading as='h2' size='h2' textAlign='center'>
            {title}
          </Heading>
        )}
        <Box height='16px' />
        <Box
          overflowX='auto'
          marginX={{
            base: '-16px',
            md: '-48px',
            xl: 'unset',
          }}
        >
          <List
            display='grid'
            gridAutoColumns='1fr'
            gridAutoFlow='column'
            gridGap='16px'
            margin='0px'
            padding='0px 0px 24px'
            width='70rem'
            paddingEnd={{
              base: '16px',
              md: '48px',
              xl: 'unset',
            }}
            paddingStart={{
              base: '16px',
              md: '48px',
              xl: 'unset',
            }}
          >
            {cards?.map((card) => (
              <ListItem key={card.title} display='flex'>
                <Card padding='40px 16px'>
                  <Glyph height={48} name={card.glyphName} width={48} />
                  <Box height='16px' />
                  <Heading as='p' size='h4'>
                    {card.title}
                  </Heading>
                  <Box height='24px' />
                  <Markdown
                    markdownText={card.markdownContent}
                    components={{
                      ul: ({ children }) => (
                        <List display='flex' flexDirection='column' gap='24px'>
                          {children}
                        </List>
                      ),
                      li: ({ children }) => (
                        <ListItem display='flex'>
                          <ListIcon as={CheckedIcon} color='blue.500' height='24px' width='24px' />
                          {children}
                        </ListItem>
                      ),
                    }}
                  />
                </Card>
              </ListItem>
            ))}
          </List>
        </Box>
      </ContentContainer>
    </Box>
  );
}
